<div class="terms-conditions-container">
  <div class="manage-autopay-header">
    <div class="manage-autopay-header-title mb-0">
        {{ 'Autopay terms and conditions' | translate }}
    </div> 
  </div>

  <span class="autopay-tc-info-container">
      <ng-container *ngIf="isAcmic; else MAstate">
          {{ 'PAYMENT_LEGAL_RECURRING' | translate }}
      </ng-container>
      <ng-template #MAstate>
          {{ (type.includes('credit/debit') ? 'CCDC_TERMS_CONDITIONS' : 'EPAY_ENROLL_LEGAL') | translate }}
      </ng-template>
  </span>

  <div class="button-row margin-top mt24">
      <mapfre-button
          [additionalClasses]="'basic primary large-btn  mx-auto'" 
          (click)="onClose()"
      >
          {{ "Close" | translate }}
      </mapfre-button>
  </div>
</div>